/* eslint-disable no-sequences */
// AXIOS
import axios from "axios";
import { apiToken, apiUrl_forProductFilters } from "./constants";

// cancel token
const CancelToken = axios.CancelToken;

// get productFilters
export let cancelGetProductFiltersApi;
export async function getProductFilters(token) {
    if (token) {
        const productFilters = await axios.get(
            apiUrl_forProductFilters + "filters",
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    cancelGetProductFiltersApi = c;
                }),
            }
        );
        return productFilters;
    } else {
        console.log("Please add required parameters");
    }
}

// update customer
export let cancelupdateProductFiltersApi;
export async function updateProductFilters(token, filterlist) {
    if ((token, filterlist)) {
        const customers = await axios.put(
            apiUrl_forProductFilters + "filters",
            filterlist,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelupdateProductFiltersApi = c;
                }),
            }
        );
        return customers;
    } else {
        console.log("Please add required parameters");
    }
}
